var $ = require('jquery');

/* Utility functions */
function createSimpleClarityToolTip(elementHTML:string = '<span>tooltip</span>', tooltipText:string = "Tooltip text", tooltipClasses:string = '"tooltip tooltip-sm tooltip-right"') {
    return '<span role="tooltip" aria-haspopup="true" class=' + tooltipClasses + '>' +
                elementHTML +
                '<span class="tooltip-content">' + tooltipText + '</span>' +
            '</span>';
}

function findObjectIndexInArray(arr, key:string, value:string):Array<number> {
    return $.map(arr, function(obj, index) {
        if(obj[key] == value) {
            return index;
        }
    })
}

function getTimezone() {
    var d  = new Date();
    var tA = d.toString().split(' ');
    var tZ = d.toString().match(/([A-Z]+[\+-][0-9]+)/);
    if (tZ && tZ[1]) {
        return tZ[1];  // Thu Aug 11 2016 16:34:17 GMT+0530 (IST) => GMT+0530
    }else if(tA instanceof Array && tA.length >= 5) {
        return tA[5];  // Thu Aug 11 2016 16:34:17 GMT+0530 (IST) => GMT+0530
    }else{
        return d.toString(); // for troubleshoot
    }
}

/* Export section */
export { createSimpleClarityToolTip as createToolTip };
export { findObjectIndexInArray as findObjectIndexInArray };
export { getTimezone as getTimezone };


// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-common/utils.ts